/* eslint-disable quotes */

import ApiService from "./api.service";
// import ApiMockService from "./api.mock.service"

const AlertsService = {
  getAllAlerts: async function (params = {}, lang = null) {
    const response = await ApiService._get("api/alert", params, lang);
    return response.data;
  },

  getById: async function (id, lang = null) {
    const response = await ApiService._get(`api/alert/${id}?withTranslations=true`, lang);
    return response.data;
  },

  create: async function (params = {}, lang = null) {
    const response = await ApiService.post("api/alert", params, lang);
    return response.data;
  },

  update: async function (id, params = {}, lang = null) {
    const response = await ApiService.put(`api/alert/${id}`, params, lang);
    return response.data;
  },

  delete: async function (id, lang = null) {
    const response = await ApiService.delete(`api/alert/${id}`, lang);
    return response.data;
  },
};

export default AlertsService;
